import '@reach/menu-button/styles.css';

import { Menu, MenuButton, MenuItem, MenuPopover } from '@reach/menu-button';
import { getCollisions } from '@reach/popover';
import VisuallyHidden from '@reach/visually-hidden';
import PropTypes from 'prop-types';
import * as React from 'react';
import { Box, Flex } from 'rebass/styled-components';
import styled from 'styled-components';

import ThreePointMenu from '@/components/Icon/ThreePointMenu';
import Text from '@/components/Text';

const ThreePoint = styled(MenuButton)`
  background: transparent;
  border-radius: 100%;
  cursor: pointer;
  outline: none;
  padding: 10px;
  border: 1px solid;
  transform: rotate(90deg);
  border-color: transparent;
`;
const ThreePointWithHover = styled(MenuButton)`
  background: transparent;
  border-radius: 100%;
  cursor: pointer;
  outline: none;
  padding: 10px;
  border: 1px solid;
  transform: rotate(0deg);
  border-color: #ebebeb;
  :hover {
    background: #fafafa;
  }
`;

const StyledMenuList = styled(Box)`
  border: none;
  border-radius: 4px;
  box-shadow: 0 0 6px 0 rgba(0, 0, 0, 0.16);
  background-color: #fff;
  padding: 8px 0;
`;

const StyledMenuItem = styled(MenuItem)`
  align-items: center;
  position: relative;
  z-index: 5;
  display: flex;
  padding: 8px 20px;
  :hover {
    background: #f7f7f7;
  }
`;
const TextBox = styled(Box)``;
TextBox.defaultProps = {
  flex: '6 0 0',
};

const style = {
  zIndex: '9000000000',
};

const ContextMenu = ({ options, rotate }) => {
  const positionDefault = (targetRect, popoverRect) => {
    if (!targetRect || !popoverRect) {
      return {};
    }
    const { directionRight, directionUp } = getCollisions(targetRect, popoverRect);
    return {
      left: directionRight
        ? `${targetRect.right - popoverRect.width + window.pageXOffset + 10}px`
        : `${targetRect.right + window.pageXOffset - popoverRect.width + 36}px`,
      top: directionUp
        ? `${targetRect.top - popoverRect.height + window.pageYOffset}px`
        : `${targetRect.top + targetRect.height + window.pageYOffset}px`,
    };
  };
  return (
    <>
      {rotate ? (
        <Menu>
          <ThreePoint>
            <VisuallyHidden />
            <ThreePointMenu />
          </ThreePoint>
          <MenuPopover position={positionDefault} style={style}>
            <StyledMenuList>
              {Object.keys(options).map((key) => (
                <StyledMenuItem key={key} onSelect={options[key].action}>
                  <Flex>{options[key].icon}</Flex>
                  <Text my={['0', '0', '0']} ml={['0.875rem', '0.875rem', '0.875rem']} variant="modalMenuItem">
                    {options[key].title}
                  </Text>
                </StyledMenuItem>
              ))}
            </StyledMenuList>
          </MenuPopover>
        </Menu>
      ) : (
        <Menu>
          <ThreePointWithHover>
            <VisuallyHidden />
            <ThreePointMenu />
          </ThreePointWithHover>
          <MenuPopover position={positionDefault} style={style}>
            <StyledMenuList>
              {Object.keys(options).map((key) => (
                <StyledMenuItem key={key} onSelect={options[key].action}>
                  <Flex>{options[key].icon}</Flex>
                  <Text my={['0', '0', '0']} ml={['0.875rem', '0.875rem', '0.875rem']} variant="modalMenuItem">
                    {options[key].title}
                  </Text>
                </StyledMenuItem>
              ))}
            </StyledMenuList>
          </MenuPopover>
        </Menu>
      )}
    </>
  );
};

ContextMenu.propTypes = {
  options: PropTypes.arrayOf(
    PropTypes.shape({
      title: PropTypes.string.isRequired,
      icon: PropTypes.node.isRequired,
      action: PropTypes.func.isRequired,
      rotate: PropTypes.string.isRequired,
    })
  ).isRequired,
  rotate: PropTypes.string.isRequired,
};

/** @component */
export default ContextMenu;
